/**
 * MA post-logout return target.
 *
 * Auth0 `logoutParams.returnTo` must be an Allowed Logout URL on the MA SPA.
 * Staging Allowed Logout URLs already include:
 *   https://staging.myaccount.krosskast.com/signin
 *   https://staging.myaccount.krosskast.com
 * Production (document only — do not change without owner approval):
 *   https://myaccount.krosskast.com/signin
 *   https://myaccount.krosskast.com
 *
 * `/signin` is the canonical MA login entrypoint: it must immediately start
 * Auth0 Universal Login (branded), never render an unbranded intermediate
 * "Sign In" button page.
 */

export const MA_POST_LOGOUT_PATH = "/signin";

export function buildPostLogoutReturnTo(origin = window.location.origin) {
  const base = String(origin || "").replace(/\/$/, "");
  return `${base}${MA_POST_LOGOUT_PATH}`;
}

/*
 * Auth0 SPA "Allowed Logout URLs" — documentation only (do not export; exported
 * arrays were emitted into the production bundle as staging/localhost literals).
 *
 * Staging:
 *   https://staging.myaccount.krosskast.com{,/signin,/logout,/callback}
 *   https://www.staging.myaccount.krosskast.com{,/signin,/logout,/callback}
 *   http://localhost:3001{,/signin}
 * Production (do not change without owner approval):
 *   https://myaccount.krosskast.com{,/signin,/logout,/callback}
 *   https://www.myaccount.krosskast.com{,/signin,/logout,/callback}
 */
